


















































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

/**
 * Utils
 */
import { getLocaleDateString } from "@/utils/date-helpers";
import { getFullName } from "@/utils/users-helpers";

/**
 * Components
 */
import CartDetails from "./CartDetails.vue";

/**
 * Types
 */
import { Cart } from '../store';

/**
 * Page de details d'une commande.
 */
@Component({
	components: { CartDetails }
})
export default class SummaryPage extends Vue {
	/** Injections */
	getLocaleDateString = getLocaleDateString;
	getFullName = getFullName;

	/** Propriétés */
	@Prop()
	cart!: Cart;

	@Prop()
	dateBooking!: Date | null;
	@Prop()
	dateBooked!: Date | null;
	@Prop()
	serviceBooked!: any | null;
	@Prop()
	userBooked!: any | null;

	/** Attributs */
	isLoading = false;

	/** Méthodes */
	async created() {
	}
}
